module.exports = __webpack_public_path__ + "img/evaluateItemLogo5.bcad0875.png";